import React from 'react';
import { Container, Card, CardHeader, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import PageMeta from './PageMeta';
import SkeletonImage from './SkeletonImage';
import '../App.css';

const GUIDE_BANNERS = [
    { href: '/guides/FAQ', internal: true, src: '/db/guides/FAQBanner.webp', alt: 'FAQ' },
    { href: 'https://docs.google.com/document/d/13507_Wa1f7kwP1yoh0L6Js8becdDReofJEwN47v0U3M/', src: '/db/guides/DOTBanner.webp', alt: 'Dungeon of Trials' },
    { href: 'https://docs.google.com/document/d/1sTdmOg1K857H7MAuzZWUV4Kk-zwABDG3hl4anyPeAQA/', src: '/db/guides/SRBanner.webp', alt: "Summoners' Road" },
    { href: 'https://docs.google.com/document/d/16IorJQQXMksXIYcNlu3i8iwWTEKeooEpgZG7l-rt4nY/', src: '/db/guides/TribalRuinsBanner.webp', alt: 'Tribal Ruins' },
    { href: 'https://docs.google.com/document/d/1OaGohMM8zZsCJ63MEosjiTP2aFStrMRZby7qKGEh6vw/', src: '/db/guides/EleRuinsBanner.webp', alt: 'Elemental Ruins' },
    { href: 'https://docs.google.com/document/d/14ztpoBP4MUjuFB1guR0shvLpERMz1r2H4DpfUdcnBMI/', src: '/db/guides/GCBanner.webp', alt: 'Grand Crusade' },
    { href: 'https://docs.google.com/document/d/14VQIZDuciBTBCOnAYlCnFxcXGajNwhwk5nnMZAV3n1o/', src: '/db/guides/MinesBanner.webp', alt: 'Magical Mines' },
];

function GuideBannerLink({ banner }) {
    const image = (
        <SkeletonImage
            src={banner.src}
            alt={banner.alt}
            loading="eager"
            frameClassName="gs-skeleton-frame--guide-banner"
        />
    );

    if (banner.internal) {
        return (
            <Link to="FAQ" className="gs-banner-link">
                {image}
            </Link>
        );
    }

    return (
        <a
            className="gs-banner-link"
            href={banner.href}
            target="_blank"
            rel="noopener noreferrer"
        >
            {image}
        </a>
    );
}

export default function GuidesMainPage () {
    return (
        <Container className="gs-page">
            <PageMeta
                title="Guides"
                description="Grand Summoners player guides including FAQ, dungeon walkthroughs, and farming references."
                path="/guides"
            />
            <div className="gs-page-gutter">
                <header className="gs-page-intro">
                    <h1>Game Guides</h1>
                    <p>FAQ and other helpful guides for Grand Summoners.</p>
                </header>

                <Card className="gs-card">
                    <CardHeader className="gs-card-header">
                        <h2><center>FAQ</center></h2>
                    </CardHeader>
                    <CardBody className="gs-card-body">
                        <div className="gs-guides-grid">
                            <GuideBannerLink banner={GUIDE_BANNERS[0]} />
                        </div>
                    </CardBody>
                </Card>

                <Card className="gs-card" style={{ marginTop: 'var(--gs-space-5)' }}>
                    <CardHeader className="gs-card-header">
                        <h2><center>External Guides</center></h2>
                    </CardHeader>
                    <CardBody className="gs-card-body">
                        <div className="gs-guides-grid">
                            {GUIDE_BANNERS.slice(1).map((banner) => (
                                <GuideBannerLink key={banner.src} banner={banner} />
                            ))}
                        </div>
                    </CardBody>
                </Card>
            </div>
        </Container>
    )
}
